<template>
  <div style="background: #eee;">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="shop-body">
      <div class="shop-user-box">
        <div class="shop-no-login-body" v-if='!loginState'>
          <div style="margin-bottom: 20px;" class="show-no-login-button" @click="enterLogin">登  录</div>
          <div class='show-no-login-button' @click="enterRegister">注  册</div>
        </div>
        <div class="shop-login-body" v-if="loginState">
          <div class="shop-login-data">
            <img :src="userAvatar" class="shop-login-image"/>
            <div class="shop-login-info">
              <div class="shop-login-account-box">
                <span class="shop-login-account">{{userNickname}}</span>
                <span style="cursor: pointer;" @click='shopQuitLogin'>[退出]</span>
              </div>
              <p>积分 : {{userIntegral}}</p>
            </div>
          </div>
          <div class='shop-login-vip'>
            <img :src="vipList[userVip].vsrc" :class="'vip-level-'+userVip"></img>
            <div class="shop-login-vip-progress">
              <span class="shop-login-vip-progress-bar" :style="{ width:vipPercentage  + '%' }"></span>
            </div>
          </div>
          <div class="shop-task-body">
            <span class="shop-task-button" @click="updateShopSign" :class="userSign == 1? 'shop-login-disable-sign':''" style="margin-right: 40px;">{{userSign == 1 ?'已签到':'今日签到'}}</span>
            <span class="shop-task-button" @click="enterWallet">我的钱包</span>
          </div>
        </div>
        <div class="shop-bottom-box">
          <div class="shop-bottom-body">
            <span style="float: left;" class="shop-bottom-span" @click="enterTask(0)">
              <i class="icon-shop-img icon-money"></i>赚取积分
            </span>
            <span style="float: right;cursor: pointer;" class="shop-bottom-span"
              @click="enterTask(3)">
              <i class="icon-shop-img icon-task"></i>我的任务>>
            </span>
          </div>
          <div class="shop-bottom-big-box">
            <span class="shop-bottom-big-span" @click="enterTask(0)">
              <i class="icon-shop-img icon-big-game"></i>游戏赚积分
            </span>
            <span class="shop-bottom-big-span" @click="enterTask(1)">
              <i class="icon-shop-img icon-big-task"></i>任务得积分
            </span>
          </div>
        </div>
      </div>
      <div class="shop-swiper-body"> 
        <div class="shop-swiper-btn shop-swiper-button-prev"><</div>
        <div id="shop_banner_swiper" class="shop-swiper-container swiper-container">
            <div class="swiper-wrapper">
                <a :href="item.banner_address" class="shop-swiper-slide swiper-slide" 
                v-for="(item, index) in bannerList" :key="index" target="_blank">
                    <img :src="baseAddress+item.banner_url"/>
                </a>
            </div>
        </div>
        <div class="shop-swiper-btn shop-swiper-button-next">></div>
        <div class="swiper-pagination shop-pagination" id="shop_pagination" slot="pagination"></div>
    </div>
    </div>
    <div class="shop-body">
      <div class="shop-item-body">
        <div class="shop-item-box" @click="enterShopMore(1)">
          <i class="shop-item-icon shop-item-goods"></i>
          <span class="shop-item-span border-bottom">虚拟商品</span>
        </div>
        <div class="border-right-line"></div>
        <div class="shop-item-box" @click="enterIntegral">
          <i class="shop-item-icon shop-item-integral"></i>
          <span class="shop-item-span border-bottom">我的积分</span>
        </div>
        <div class="border-right-line"></div>
        <div class="shop-item-box" @click="enterMineShop">
          <i class="shop-item-icon shop-item-order"></i>
          <span class="shop-item-span border-bottom">订单管理</span>
        </div>
        <div class="shop-item-box" @click="enterMineInfo">
          <i class="shop-item-icon shop-item-address"></i>
          <span class="shop-item-span">收货地址</span>
        </div>
        <div class="border-right-line"></div>
        <div class="shop-item-box" @click="enterQuestion">
          <i class="shop-item-icon shop-item-question"></i>
          <span class="shop-item-span">常见问题</span>
        </div>
        <div class="border-right-line"></div>
      </div>
      <div class="shop-recommend-body">
        <div class="shop-recommend-item shop-item" v-for="(item,index) in recommendList"
          :class="[item.shop_hot == 1 ? 'shop-item-border-orange' : item.shop_recommend == 1 ? 'shop-item-border-blue' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-border-green' : '']">
          <span class="shop-recommend-label">推荐商品</span>
          <i class="shop-item-ic" :class="item.shop_hot == 1 ? 'shop-item-hot' : item.shop_recommend == 1 ? 'shop-item-recommend' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-new' : 'shop-hide'"></i>
          <div class="shop-recommend-avatar">
            <img class="shop-recommend-img" :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
            <i class="shop-recommend-subscript"></i>
          </div>
          <div class="shop-recommend-data">
            <span class="shop-recommend-title">{{item.shop_name}}</span>
            <span class="shop-recommend-price">积分价格 : <i>{{item.shop_consume_count}}</i></span>
            <div class="shop-recommend-buy" @click="enterShopDetails(item.shop_id)">立即购买</div>
          </div>
        </div>
      </div>
    </div>
    <div class="shop-body" style="display: block;overflow: hidden;">
      <span class="shop-body-label">虚拟商品</span>
      <span class="shop-body-more" @click="enterShopMore(1)">
        查看全部
        <i class="shop-body-more-icon"></i>
      </span>
    </div>
    <div class="shop-body">
      <div class="shop-ad" @click="enterShopDetails(giftId)">
        <img class="shop-ad-img" :src="baseAddress+giftAddress">
      </div>
      <div class="shop-recommend-body">
        <div style="margin-bottom: 10px;" :class="[index%3 == 2 ? 'mr-0':'',item.shop_hot == 1 ? 'shop-item-border-orange' : item.shop_recommend == 1 ? 'shop-item-border-blue' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-border-green' : '']" v-for="(item,index) in giftList"
        class="shop-recommend-item shop-item">
          <span class="shop-recommend-label">推荐商品</span>
          <i class="shop-item-ic" :class="item.shop_hot == 1 ? 'shop-item-hot' : item.shop_recommend == 1 ? 'shop-item-recommend' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-new' : 'shop-hide'"></i>
          <div class="shop-recommend-avatar">
            <img class="shop-recommend-img" :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
            <i class="shop-recommend-subscript"></i>
          </div>
          <div class="shop-recommend-data">
            <span class="shop-recommend-title">{{item.shop_name}}</span>
            <span class="shop-recommend-price">积分价格 : <i>{{item.shop_consume_count}}</i></span>
            <div class="shop-recommend-buy" @click="enterShopDetails(item.shop_id)">立即购买</div>
          </div>
        </div>
      </div>
    </div>

    <div class="shop-body" style="display: block;overflow: hidden;">
      <span class="shop-body-label">实物商品</span>
      <span class="shop-body-more" @click="enterShopMore(2)">
        查看全部
        <i class="shop-body-more-icon"></i>
      </span>
    </div>
    <div class="shop-body">
      <div class="shop-ad" @click="enterShopDetails(matterId)">
        <img class="shop-ad-img" :src="baseAddress+matterAddress">
      </div>
      <div class="shop-matter-body" style="margin-left: 30px;">
        <div :class="[index%2 == 1 ? 'mr-0':'',item.shop_hot == 1 ? 'shop-item-border-orange' : item.shop_recommend == 1 ? 'shop-item-border-blue' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-border-green' : '']"
           class="shop-recommend-item shop-matter-item" v-for="(item,index) in matterList">
          <i class="shop-item-ic" :class="item.shop_hot == 1 ? 'shop-item-hot' : item.shop_recommend == 1 ? 'shop-item-recommend' : 86400000 > nowTime - item.shop_create_time ? 'shop-item-new' : 'shop-hide'"></i>
          <img class="shop-matter-img" :src="baseAddress+item.shop_preview">
          <div class="shop-matter-data">
            <span class="shop-matter-title"><i class="shop-recommend-title-icon"></i>{{item.shop_name}}</span>
            <span class="shop-matter-price">积分 : <i>{{item.shop_consume_count}}</i></span>
            <div style="margin: 0 auto;" class="shop-recommend-buy" @click="enterShopDetails(item.shop_id)">立即购买</div>
          </div>
        </div>
      </div>
    </div>
    <div class="shop-body" style="display: block;overflow: hidden;">
      <span class="shop-body-label">任务中心</span>
      <span class="shop-body-more" @click="enterTask(0)">
        查看全部
        <i class="shop-body-more-icon"></i>
      </span>
    </div>
    <div class="shop-body" style="margin-bottom: 34px;display: block;height: 330px;">
      <div :class="index%4 == 3 ? 'mr-0':''" class="shop-task-item" v-for="(item,index) in taskList">
        <i class="shop-item-ic shop-item-not-done" v-if="4 > item.task_complete"></i>
        <i class="shop-item-ic shop-item-done" v-if="item.task_complete == 4"></i>
        <img class="shop-task-img" :src="baseImageAddress+'type=hall&game_tag='+item.game_tag">
        <div class="shop-task-data">
          <span class="shop-task-integral">积分 : <i>{{item.task_integral_param}}</i></span>
          <span class="shop-task-count">剩余 : {{item.task_remain}}个</span>
        </div>
        <div class="shop-task-receive" @click="getGameTask(item,item.game_gid,item.game_sid)" v-if="item.task_complete == 1">
          领取任务
        </div>
        <div class="shop-task-receive" @click="getGameTaskReward(item,item.game_gid,item.game_sid)" v-if="item.task_complete == 2 || item.task_complete == 3">
          领取积分
        </div>
        <div class="shop-task-receive task-done-receive" v-if="item.task_complete == 4">已完成</div>
        <span class="shop-task-hint">{{handlerTask(item.game_name,item.game_area_name,item.task_param,item.task_integral_param)}}</span>
        <div class="shop-task-time">
          <i class="icon shop-i-time"></i>
          仅剩<i class="day">{{Djs_time_list(item.task_end_time,0)}}</i>天
          <i class="hour">{{Djs_time_list(item.task_end_time,1)}}</i>时
          <i class="minute">{{Djs_time_list(item.task_end_time,2)}}</i>分
          <i class="second">{{Djs_time_list(item.task_end_time,3)}}</i>秒
        </div>
      </div>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
    <div v-show="showTaskState" class="pop-mask" @click="closePop"></div>
    <div v-show="showTaskState" class="pop-task-body">
      <div class="pop-bd">
        <h2 class="title">领取任务</h2>
        <div class="txt">
          <p class="tc">{{showTaskDesc}}</p>
        </div>
        <div class="opt tc">
          <a v-if="showTaskType == 0" @click="enterGameSelect">前往做任务</a>
          <a v-if="showTaskType == 1" @click="closePop">继续任务</a>
          <a v-if="showTaskType == 2" @click="closePop">关闭</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Footer from "../../components/common/Footer";
  import Header from '../../components/common/Header';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import Swiper from "swiper";
  import "swiper/css/swiper.css";
  export default {
    components: {
      Footer, Header, SuspendSide,SuspendMember
    },
    metaInfo(){
      return {
        title:"商品中心_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    computed:{
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      GameTransfer(){
        return this.$store.state.constant.GameTransfer;
      },
      recommendList(){
        return this.$store.state.shop.recommendList;
      },
      bannerList(){
        return this.$store.state.shop.bannerList;
      },
      giftList(){
        return this.$store.state.shop.giftList;
      },
      matterList(){
        return this.$store.state.shop.matterList;
      },
      taskList(){
        return this.$store.state.shop.taskList;
      },
      //礼包商品数据
      giftState(){
        return this.$store.state.shop.giftState;
      },
      giftId(){
        return this.$store.state.shop.giftId;
      },
      giftAddress(){
        return this.$store.state.shop.giftAddress;
      },
      //实物商品数据
      matterState(){
        return this.$store.state.shop.matterState;
      },
      matterId(){
        return this.$store.state.shop.matterId;
      },
      matterAddress(){
        return this.$store.state.shop.matterAddress;
      },
      vipList(){
        return this.$store.state.constant.vipList;
      }
    },
    asyncData({store,route}){
      return store.dispatch('initShop');
    },
 
    data() {
      return {
        loginState:false,
        userNickname:'',
        userIntegral:"69",
        userVip:0,
        vipPercentage:0,
        userAvatar:'',
        userSign:'',
        bannerSwiperOption:{
          autoplay:{
            disableOnInteraction:false
          },
          slidesPerView: 1,
          loop: true, 
          speed: 600,
          navigation: {
              prevEl: ".shop-swiper-button-prev",
              nextEl: ".shop-swiper-button-next",
          },
          pagination:{
            el:"#shop_pagination",
            clickable:true
          }
        },
        bannerSwiper:'',
        suspendState:false,
        suspendType:0,
        nowTime:0,
        gameBean:{ //游戏参数
          type:0, //游戏类型
          sid:0, //游戏区服
          out_sid:0, //游戏h5区服
          tag:'', //游戏标识
          gid:'' //游戏序号
        },
        showTaskState:false, 
        showTaskDesc:'',
        showTaskType:0, //任务弹窗类型 0:游戏类型 1:日常任务
        timer:"",
        serverTime:0,
      };
    },
    mounted(){
      if (window.sessionStorage.getItem("token") !== null) {
        this.loginState=true;
        this.initUser();
      }
      this.initBannerSwiper();
      this.nowTime = new Date().getTime();
      this.serverTime = new Date().getTime();
      this.Djs_time();
    },
    methods:{
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      initBannerSwiper(){
        this.bannerSwiper = null;
        this.bannerSwiper = new Swiper("#shop_banner_swiper",this.bannerSwiperOption);
      },
      initUser(){
        this.$http.post('/query_mine_center', {})
        .then(res=>{
          if(res.data.code == 2000){
            var user = res.data.data;
            this.userNickname = user.user_nickname;
            window.sessionStorage.setItem("userNickname",this.userNickname);
            this.userVip = user.user_vip;
            window.sessionStorage.setItem("userVip",this.userVip);
            this.userIntegral = user.user_integral;
            window.sessionStorage.setItem("userIntegral",this.userIntegral);
            window.sessionStorage.setItem("userVipMax",user.user_vip_max);
            window.sessionStorage.setItem("userVipCurrent",user.user_vip_current);
            this.vipPercentage = (user.user_vip_current / user.user_vip_max) * 100 +"";
            if(isNaN(this.vipPercentage)){
              this.vipPercentage = 0;
            }
            window.sessionStorage.setItem("vipPercentage",this.vipPercentage); 
            if(user.user_avatar != null && user.user_avatar.length > 0){
              if(user.user_avatar.indexOf("http") === -1){
                this.userAvatar = this.baseAddress+user.user_avatar;
              }else{
                this.userAvatar = user.user_avatar;
              }
            }else{
              this.userAvatar = this.baseAddress+"img/common_default_avatar_normal.jpg";
            }
            window.sessionStorage.setItem("userAvatar",this.userAvatar); 
            this.userSign = user.user_sign_state;
            window.sessionStorage.setItem("userSign",this.userSign);
          }
        })
      },
      enterLogin(){
        this.changeSuspendType(0);
        this.changeSuspendState(true);
      },    
      enterRegister(){
        this.changeSuspendType(1);
        this.changeSuspendState(true);
      },
      enterShopDetails(value) {
        window.open(this.$router.resolve({name:'shopDetails',query:{sid:value}}).href,"_blank");
      },
      enterWallet(){
        if(this.loginState){
          window.open(this.$router.resolve({name:"mineWallet"}).href,"_blank");
        }else{
          this.enterLogin();
        }
      },
      enterIntegral(){
        if(this.loginState){
          window.open(this.$router.resolve({name:"mineIntegral"}).href,"_blank");
        }else{
          this.enterLogin();
        }
      },
      enterMineShop(){
        if(this.loginState){
          window.open(this.$router.resolve({name:"mineShop"}).href,"_blank");
        }else{
          this.enterLogin();
        }
      },
      enterMineInfo(){
        if(this.loginState){
          window.open(this.$router.resolve({name:"mineInfo"}).href,"_blank");
        }else{
          this.enterLogin();
        }
      },
      enterQuestion(){
        window.open(this.$router.resolve({name:"question"}).href,"_blank");
      },
      enterTask(value){
        window.open(this.$router.resolve({name:`task`,query:{type:value}}).href,"_blank");
      },
      enterRecharge(){
        window.open(this.$router.resolve({name:"recharge"}).href,"_blank");
      },
      shopQuitLogin(){
        this.loginState = false;
        window.sessionStorage.clear();
        window.localStorage.clear();
      },
      updateShopSign(){
        if(this.loginState&&this.userSign != 1){
          this.$http.post(`/update_web_mine_sign`,{data:1})
          .then(res=>{
            if(res.data.code == 2000){
              alert("签到成功!");
              this.userSign = 1;
              this.userIntegral = parseInt(this.userIntegral) + parseInt(1);
              window.sessionStorage.setItem("userIntegral",this.userIntegral);
              window.sessionStorage.setItem("userSign",1);
            }else{
              alert(res.data.msg);
            }
          })   
        }
      },
      handlerTask(name,areaName,param,integral){
        return "登陆《"+name+"》"+areaName+",玩游戏到"+param+"级,领"+integral+"积分。";
      },
      getTaskValue(value){
        switch(value){
          case 0:
          case 4:
            return "领奖励";
          case 1:
            return "已完成";
          default:
            return "未完成";
        }
      },
      enterShopMore(value){
        window.open(this.$router.resolve({name:"shopMore",query:{type:value}}).href,"_blank");
      },
       //游戏任务处理函数
      getGameTask(item,gid,sid){
        if(this.loginState){    
          this.gameBean.type = item.game_device;
          this.gameBean.tag = item.game_tag;
          this.gameBean.gid = item.game_gid;
          this.gameBean.sid = item.game_sid_id;
          this.gameBean.out_sid = 1;
          this.$http.post("/get_game_task?tid="+item.task_id+"&sid="+sid+"&gid="+gid,
          {}).then(res=>{   
            this.showTaskType = 0;
            if(res.data.code == 1155 || res.data.code == 1158){
              //领取任务完成 和 
              item.task_complete = 3;
              this.showTaskState = true;
              if(res.data.data == 6){
                //第一次运行
                this.showTaskDesc = "恭喜您,任务申请成功。";
                this.taskTotal = this.taskTotal + 1;
              }else{
                //多次运行
                this.showTaskDesc = "任务还没有完成哦!登陆"+item.game_name+"进入双线"+item.game_sid+"服,创建角色后把角色等级提升至"+item.task_param+"级,即可完成任务"
              }
            }else{
              alert(res.data.msg);
            }
          });
        }else{
          this.enterLogin();
        }
      },
      //任务奖励处理函数
      getGameTaskReward(item,gid,sid){
        if(this.loginState){    
          this.gameBean.type = item.game_device;
          this.gameBean.tag = item.game_tag;
          this.gameBean.gid = item.game_gid;
          this.gameBean.sid = item.game_sid_id;
          this.gameBean.out_sid = 1;
          this.$http.post("/get_game_task_reward?tid="+item.task_id+"&sid="+sid+"&gid="+gid,
          {}).then(res=>{   
            this.showTaskType = 0;
            if(res.data.code == 1155 || res.data.code == 1158){
              //领取任务完成 和 
              item.task_complete = 3;
              this.showTaskState = true;
              //多次运行
              this.showTaskDesc = "任务还没有完成哦!登陆"+item.game_name+"进入双线"+item.game_sid+"服,创建角色后把角色等级提升至"+item.task_param+"级,即可完成任务"
            }else if(res.data.code == 1156){
              //完成任务
              //处理结果(弹窗,并且设置逻辑)
              item.task_complete = 4;
              this.showTaskDesc = "恭喜您完成此次任务获得了积分奖励!"
              this.showTaskState = true;
              this.showTaskType = 2;
              this.userIntegral = parseInt(this.userIntegral) + parseInt(item.task_integral_param);
              window.sessionStorage.setItem("userIntegral",this.userIntegral);
            }else{
              alert(res.data.msg);
            }
          });
        }else{
          this.enterLogin();
        }
      },
      closePop(){
        this.showTaskState = false;
      },
      enterGameSelect(){
        if(this.gameBean.type == 1){
          this.enterGameExact(this.gameBean.gid,this.gameBean.sid);
        }else if(this.gameBean.type == 3){
          this.enterH5Game(this.gameBean.gid,0,this.gameBean.tag);
        }else{
          this.enterDownload(this.gameBean.tag);
        }
      },
      enterH5Game(gid,out_sid,tag){
        window.open(this.$router.resolve({ name: 'enterH5', query:{gid:gid,sid:out_sid,path:this.$route.path,tag:tag}}).href,'_blank');
      },
      enterDownload(value){
        window.open(this.$router.resolve({ name: 'transfer', query:{tag: value, type: this.GameTransfer} }).href, '_blank'); 
      },
      enterGameExact(gid,sid){
        if(this.loginState){
          window.open(this.$router.resolve({ name: 'gameEnter', query:{gid:gid,sid:sid}}).href,'_blank');
        }else{
          this.enterLogin();
        }
      },
      Djs_time:function(){
        this.timer = setInterval(() =>{
          this.serverTime = this.serverTime + 1000;
        },1000);
      },
      Djs_time_list:function(itemEnd,type){
        var rightTime = itemEnd - this.serverTime;
        if(rightTime > 0){
          if(type == 0){
            return Math.floor(rightTime / 1000 / 60 / 60 / 24);
          }else if(type == 1){
            return Math.floor((rightTime / 1000 / 60 / 60) % 24);
          }else if(type == 2){
            return Math.floor((rightTime / 1000 / 60) % 60);
          }else{
            return Math.floor((rightTime / 1000) % 60);
          }
        }else{
          return "0";
        }
      },
    },
    watch:{
      loginState : function(value){
        if(value){
          //登陆状态
          this.initUser();
        }
      },
      bannerList : function(){
        this.$nextTick(function(){
          this.initBannerSwiper();
        })
      },
    },
    destroyed(){
      clearInterval(this.timer);
    }
  };
</script>
<style src="@/assets/css/shop/shop.css" scoped></style>
<style>
  .shop-pagination .swiper-pagination-bullet{
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 8px;
    text-indent: -9999px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid #bfa06c;
    border-radius: 50%;
    background: #5d4e36;
    opacity: 1;
  }
  .shop-pagination .swiper-pagination-bullet-active{
    border-color: #5d4e36;
    background: #bfa06c;
    opacity: 1;
  }
</style>
